<template>
  <div>
    <!--广告图片-->
    <ad-banner/>
    <!--头部总信息展示-->
    <div class="text-left base-wrap pt-3 pb-1">
      <span>目前已有 <span class="text-login">{{TotalActivity}}</span> 个活动</span>
      <span>正在进行的有 <span class="text-success">{{UnderwayActivity}}</span> 个活动</span>
      <span>已过期 <span class="text-danger">{{ExpiredActivity}}</span> 个活动</span>
    </div>
    <!--信息卡片展示-->
    <div v-for="(item,index) in ActivityList" :key="index" id="activity_list">
      <list-card :info-item="item"/>
    </div>
    <el-pagination background layout="prev, pager, next" class="mt-4 mb-4"
                   :total=Number(TotalActivity) :current-page=current
                   @current-change='pageChange'/>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions} from 'vuex'
  import AdBanner from '../IndexComps/AdBanner'
  import ListCard from '../IndexComps/HotelActivity/ListCard'

  export default {
    name: 'HotelActivity',
    components: {AdBanner, ListCard},
    data() {
      return {
        current: 1,                                             //当前显示页面
      }
    },
    computed: {
      ...mapState(['userLoginMessage', 'ActivityList', 'ExpiredActivity', 'UnderwayActivity', 'TotalActivity']),
      ...mapGetters(['userInfo']),
    },
    mounted() {
      this.getActivityList();
    },
    methods: {
      ...mapActions(['GetActivityList']),
      /*获取酒店活动列表*/
      getActivityList() {
        this.GetActivityList({
          page: this.current,
          num: 10
        })
      },
      pageChange(currentPage) {
        this.current = currentPage;
        this.getActivityList();
      }
    }
  }
</script>
<style scoped lang="scss">
  /*::v-deep .el-pager li{*/
    /*background-color : transparent;*/
  /*}*/
  /*.el-pagination ::v-deep button:disabled  {*/
    /*background-color: transparent;*/
  /*}*/
  ::v-deep .el-pagination .btn-prev, ::v-deep .el-pagination .btn-next  {
    background-color:transparent;
  }
  ::v-deep.el-pagination.is-background .el-pager li{
    background: white;
    border-radius: 50%;
    color: var(--smtc-color-primary); 
  }
  ::v-deep.el-pagination{
    .btn-prev,.btn-next{
      color:var(--smtc-color-primary);
      border-radius: 50%;
      background-color:white !important;
    }
  }
</style>
